
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"29","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M2.8 14.03c1.46 0 2.433-.973 2.433-2.434l-.007-.767s-.362-2.176 2.54-2.176l11.756.08v3.105a1.464 1.464 0 002.064 0l4.54-4.539a1.465 1.465 0 000-2.065L21.587.426a1.465 1.465 0 00-2.064 0v3.256c-.285-.083-11.388-.131-11.388-.131-6.549 0-7.982 4.286-7.982 6.012v1.82A2.647 2.647 0 002.8 14.03zM23.907 14.102c-1.461 0-2.647 1.03-2.647 2.492l.003 1.689c-.08.63-1.138 1.04-2.69 1.04H7.032l-.004-2.75a1.464 1.464 0 00-2.065 0L.426 21.112a1.465 1.465 0 000 2.064l4.538 4.54a1.458 1.458 0 002.065 0l.004-3.267h11.54c6.548 0 7.98-4.31 7.98-6.037v-1.82c0-1.46-1.185-2.49-2.646-2.49z","fill":"#fff"}})])
          )
        }
      }
    